import { useBrowser } from '@/modules/dashboard/compositions'
import { computed, onBeforeUnmount, watch } from 'vue'

// Page navigation issue: In Moderation phase when the user presses the back button different browsers react differently.
// Chrome desktop: cache restoration does not happen and Chrome just reloads the page.
// iOS (Safari and Chrome) and Safari desktop: cache(BFcache) is supposedly used to restore the states but in the
// case when using a microphone or camera stream the browser hangs in a limbo state and is known to have been caused
// by a MediaStream teardown failure during a Back-Forward Cache (BFcache) transition. Rely on pageshow events to
// check persisted data usage if so perform a hard reload. This is the earliest stage that this listener needs to be hooked.
const useOnPageShow = () => {
  const { isSafariAny, isIos } = useBrowser()
  const isBrowserUsingPersistedCache = computed(() => isSafariAny || isIos.value)

  const onPageShow = (event: PageTransitionEvent) => {
    if (!event.persisted) return
    console.warn(`'pageshow' event triggered, page was restored from BFcache. Reloading.`)
    window.location.reload()
	}

  watch(isBrowserUsingPersistedCache, (newVal) => {
    if (newVal) {
      window.addEventListener('pageshow', onPageShow)
    } else {
			window.removeEventListener('pageshow', onPageShow)
		}
  }, { immediate: true })

  onBeforeUnmount(() => window.removeEventListener('pageshow', onPageShow))
}

export default useOnPageShow
